import CreateAdminRoleDialog from './createAdminRoleDialog.container';

export default CreateAdminRoleDialog;
